<template>
  <div class="ai-platform-page hero-keep-origin">
    <div class="ai-hero-banner">
      <img src="@/assets/jiejue/custom/traffic-compression-hero-banner.png" alt="" srcset="" style="width: 100%" @load="loaded = true" :class="{ show: loaded }" class="top_img">
      <div class="ai-hero-title">流量压缩解决方案</div>
    </div>

    <nav class="product-tabs-bar">
      <a class="product-tab" :class="{ active: activeTab === 'background' }" href="#background" @click.prevent="scrollTo('background')">需求背景</a>
      <a class="product-tab" :class="{ active: activeTab === 'challenges' }" href="#challenges" @click.prevent="scrollTo('challenges')">业务挑战</a>
      <a class="product-tab" :class="{ active: activeTab === 'scenarios' }" href="#scenarios" @click.prevent="scrollTo('scenarios')">场景应用</a>
      <a v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" class="product-tab" :class="{ active: activeTab === 'architecture' }" href="#architecture" @click.prevent="scrollTo('architecture')">部署示意图</a>
      <a class="product-tab" :class="{ active: activeTab === 'advantages' }" href="#advantages" @click.prevent="scrollTo('advantages')">方案优势</a>
      <a class="product-tab" :class="{ active: activeTab === 'cases' }" href="#cases" @click.prevent="scrollTo('cases')">典型案例</a>
    </nav>

    <div class="product-body">
    <section id="background" class="product-section section-row ai-platform-block" :class="{ 'animate-in': backgroundVisible }">
      <div class="section-title">需求背景</div>
      <div class="section-content">
        <div class="background-card">
          <p class="case-text case-text-full">
            本方案基于流量压缩过滤技术，通过自动化识别、高效压缩与安全过滤，实现网络流量的智能化管理。系统能够实时识别并分类各类网络流量，并对重复数据包进行深度压缩，从而显著减轻安全设备的处理负担，提升整体网络检测效率。该方案适用于企业网络、数据中心及边缘计算等多种复杂场景，有助于客户优化网络资源配置，增强通信链路的可靠性与安全性，同时有效降低运营成本。
          </p>
        </div>
      </div>
    </section>

    <section id="challenges" class="product-section section-row ai-platform-block" :class="{ 'animate-in': challengesVisible }">
      <div class="section-title">业务挑战</div>
      <div class="section-content">
      <div class="grid-2">
        <div class="card">
          <img class="card-icon" src="@/assets/jiejue/TrafficCompression/1.svg" alt="icon" />
          <div class="card-text">
            <div class="card-title">流量混杂导致安全防护低效</div>
            <div class="card-desc">企业网络中业务与非业务流量交织，社交、视频等无关流量占用大量带宽，致使安全设备需处理海量冗余数据，威胁检测响应延迟增加，核心业务安全保障被削弱；未知流量缺乏定向管控机制，易成为恶意攻击的“隐蔽通道”，漏检风险居高不下。</div>
          </div>
        </div>
        <div class="card">
          <img class="card-icon" src="@/assets/jiejue/TrafficCompression/2.svg" alt="icon" />
          <div class="card-text">
            <div class="card-title">带宽成本高与资源浪费并存</div>
            <div class="card-desc">数据中心内部及跨中心传输中，重复数据包占比高，导致带宽资源被无效占用，企业需持续投入额外成本扩容；虚拟机与容器混跑场景下，流量分配无序，进一步加剧资源浪费，降低服务交付效率。</div>
          </div>
        </div>
        <div class="card">
          <img class="card-icon" src="@/assets/jiejue/TrafficCompression/3.svg" alt="icon" />
          <div class="card-text">
            <div class="card-title">边缘节点部署与防护受限</div>
            <div class="card-desc">边缘计算场景中，节点资源有限，传统流量管理设备体积大、资源占用高，难以适配部署需求；同时，IoT设备等边缘终端产生的海量分散流量缺乏实时过滤能力，数据泄露与恶意入侵风险突出。</div>
          </div>
        </div>
        <div class="card">
          <img class="card-icon" src="@/assets/jiejue/TrafficCompression/4.svg" alt="icon" />
          <div class="card-text">
            <div class="card-title">架构兼容与扩展能力不足</div>
            <div class="card-desc">现有流量管理方案多基于传统架构开发，难以适配云原生环境，与K8s等容器平台集成繁琐；企业业务扩张时，方案无法快速弹性扩展，导致服务连续性与业务发展需求脱节。</div>
          </div>
        </div>
      </div>
      </div>
    </section>

    <section id="scenarios" class="product-section section-row ai-platform-block" :class="{ 'animate-in': scenariosVisible }">
      <div class="section-title">场景应用</div>
      <div class="section-content">
      <div class="scenarios">
        <div class="scenario-text">
          <div class="scenario-item">
            <div class="item-title">企业网络安全防护场景</div>
            <div class="item-desc">针对企业非业务流量干扰、安全设备负载过高的问题，方案通过智能流量识别模块自动标记社交、视频、在线娱乐等非业务流量，精准过滤并拦截此类冗余数据，将核心算力集中用于业务流量检测。同时，系统动态同步全球Top网站IP白名单，快速识别低风险流量并放行，减少安全设备无效处理；对未知流量自动转发至多层检测设备，确保企业内网无安全死角。例如，某制造业企业部署后，非业务流量占比从42%降至15%，安全设备威胁响应速度提升60%。
</div>
          </div>
          <div class="scenario-item">
            <div class="item-title">数据中心流量优化场景</div>
            <div class="item-desc">面向数据中心虚拟机与容器混跑的复杂环境，方案通过机器学习算法实现毫秒级流量分类，精准识别重复数据包并进行深度压缩，降低跨节点传输的带宽占用。针对跨数据中心的大流量传输场景，系统动态调整压缩策略，结合智能流量分配机制避免网络拥堵。某金融数据中心应用后，重复数据包压缩率达35%，跨中心数据传输时间缩短40%，每年带宽成本降低近300万元。</div>
          </div>
        </div>
        <!-- <div class="scenario-image" aria-label="AI 芯片示意图"></div> -->
         <img src="@/assets/jiejue/TrafficCompression/right.png" alt="" style="width: 50%; border-radius: 4px;" class="mobile-hidden-img">
      </div>
      </div>
    </section>

    <section v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" id="architecture" class="product-section section-row ai-platform-block" :class="{ 'animate-in': architectureVisible }">
      <div class="section-title">部署示意图</div>
      <div class="section-content">
      <img src="@/assets/solutions/deploy/traffic-compression.svg" alt="部署示意图" class="architecture-image">
      </div>
    </section>

    <section id="advantages" class="product-section section-row advantages ai-platform-block" :class="{ 'animate-in': advantagesVisible }">
      <div class="section-title">方案优势</div>
      <div class="section-content">
      <div class="grid-4">
        <div class="adv-card">
          <!-- <div class="adv-badge">1</div> -->
           <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge"/>
          <div class="adv-title">智能精准的流量识别能力</div>
          <div class="adv-desc">融合自动化DNS解析与深度应用识别技术，构建“白名单识别+应用标记+未知定向”的三重识别体系。全球Top网站IP白名单实时更新，低风险流量识别准确率达99.5%</div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/2.svg" alt="" class="adv-badge"/>
          <div class="adv-title">极致高效的流量压缩效果</div>
          <div class="adv-desc">基于机器学习的流量分类算法，实现毫秒级流量处理，过滤准确率超99%；针对重复数据包采用差分压缩技术，带宽占用降低30%以上，部分数据密集型场景压缩率可达50%</div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/3.svg" alt="" class="adv-badge"/>
          <div class="adv-title">轻量化高兼容的部署架构</div>
          <div class="adv-desc">采用DPDK技术，CPU利用率降低50%，转发性能提升3倍，适配从边缘到数据中心的全场景部署。深度兼容K8s、Docker等云原生环境，提供Helm Chart实现秒级扩容，满足业务弹性发展需求</div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/4.svg" alt="" class="adv-badge"/>
          <div class="adv-title">全场景覆盖的安全防护体系</div>
          <div class="adv-desc">构建“前端过滤+中端检测+后端审计”的全链路安全防护机制，前端过滤非业务与恶意流量，中端定向推送未知流量至专业安全设备，后端生成详细流量日志用于审计追溯</div>
        </div>
      </div>
      </div>
    </section>

    <section id="cases" class="product-section section-row ai-platform-block" :class="{ 'animate-in': casesVisible }">
      <div class="section-title">典型案例</div>
      <div class="section-content section-content-cases">
        <div class="case-content case-content-blink">
          <div class="case-section">
            <h3 class="case-subtitle">需求背景</h3>
            <p class="case-text">
              某大型矿业企业在偏远山区拥有多个矿区，矿区无公网覆盖，日常巡检视频需通过卫星链路传输至总部运维中心。当前，企业面临的核心痛点是：卫星带宽资源稀缺，流量资费高昂，传统视频传输方式未进行高效压缩，1080P高清视频每秒产生的数据量巨大，导致单次巡检的卫星流量资费居高不下；矿区卫星链路受天气、云层干扰，带宽波动大，视频传输易卡顿、花屏；前端巡检设备的编码效果差，视频流包含大量无效数据，进一步浪费卫星流量；同时，需保障巡检视频的高清画质，满足总部运维人员的实时监控和后续追溯需求。为解决流量成本高、传输不稳定的问题，企业引入流量压缩解决方案，实现卫星传输流量的优化与成本控制。
            </p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">用户痛点</h3>
            <ul class="case-list">
              <li>1. 流量压缩效率要求高：需在保障高清画质的前提下，大幅压缩视频数据量，降低卫星流量消耗，控制资费成本；</li>
              <li>2. 链路适配难度大：卫星链路带宽波动大、延迟高，易受干扰，需实现流量压缩与链路状态的动态适配，避免传输卡顿；</li>
              <li>3. 前端视频优化难：前端巡检设备编码效果差，视频流包含冗余帧、无效像素，需进一步优化，减少无效数据传输；</li>
              <li>4. 兼容性要求高：需适配现有巡检设备和总部监控平台，无需大规模改造现有系统，确保方案快速落地。</li>
            </ul>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">解决方案</h3>
            <ul class="case-list">
              <li>1. 采用极致压缩编码技术：在前端巡检设备上加装流量压缩编码板，采用H.265（HEVC）超低码率编码技术，相比传统H.264编码，在相同1080P高清画质下，数据压缩效率提升50%以上，仅需1M带宽即可流畅传输1080P视频，将卫星传输流量资费降至原先的1/5，大幅降低运营成本。</li>
              <li>2. 动态适配卫星链路：编码板搭载PID控制的自适应带宽编码技术，实时监测卫星信道状态，动态调整视频分辨率、码率、帧率等参数，在卫星信号受干扰时，自动降低非核心画面的码率，优先保障关键区域的高清传输，避免卡顿、花屏。</li>
              <li>3. 二次编码优化，剔除无效数据：针对前端设备编码效果差的问题，启用二次编码功能，对前端视频流重新优化压缩，剔除画面中的冗余帧、无效像素，进一步减少数据量，叠加H.265编码效果，实现流量消耗的最大化降低。</li>
              <li>4. 保障兼容性与传输稳定性：编码板支持国标GB28181平台对接，可无缝融入企业现有监控系统，无需改造后端平台；搭载FEC前向纠错技术与UDP快速冗余容错机制，即便压缩后的数据出现部分丢包，也能通过冗余数据自动修复，确保视频传输稳定；同时支持轻量化设计，70g的超轻重量、5W低功耗，不增加巡检设备的携带负担。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    </div>

    
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from '@/data/solutionUi.js'
import trafficCompressionBanner from '@/assets/jiejue/custom/traffic-compression-hero-banner.png'
const loaded = ref(false)
// 这里写即可，代替 export default
defineOptions({
  banner: trafficCompressionBanner
})
const backgroundVisible = ref(false)
const challengesVisible = ref(false)
const scenariosVisible = ref(false)
const architectureVisible = ref(false)
const advantagesVisible = ref(false)
const casesVisible = ref(false)

const activeTab = ref('background')
const scrollTo = (id) => {
  const el = document.getElementById(id)
  if (!el) return
  
  // 立即设置activeTab，确保点击时立即高亮
  activeTab.value = id
  history.replaceState(null, '', `#${id}`)
  
  // 设置标志，表示这是程序触发的滚动
  isScrollingProgrammatically.value = true
  
  // 滚动到目标元素
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    const stickyOffset = 120
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
  
  // 滚动完成后，重置标志，允许IntersectionObserver再次工作
  setTimeout(() => {
    isScrollingProgrammatically.value = false
  }, 1000) // 给滚动足够的时间完成
}

// 用于动画的观察器
const animationObserver = ref(null)
// 用于导航高亮的观察器
const navObserver = ref(null)
const navTimeout = ref(null)
const isScrollingProgrammatically = ref(false) // 添加标志，防止程序滚动时覆盖activeTab

// 观察所有区块的函数
const observeBlocks = () => {
  // 动画观察器
  animationObserver.value = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.id
        // 根据区块ID设置对应的可见性变量
        if (id === 'background') backgroundVisible.value = true
        else if (id === 'challenges') challengesVisible.value = true
        else if (id === 'scenarios') scenariosVisible.value = true
        else if (id === 'architecture') architectureVisible.value = true
        else if (id === 'advantages') advantagesVisible.value = true
        else if (id === 'cases') casesVisible.value = true
      }
    })
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' })

  // 导航高亮观察器
  navObserver.value = new IntersectionObserver((entries) => {
    // 如果是程序触发的滚动，暂时不更新activeTab
    if (isScrollingProgrammatically.value) return;
    
    // 过滤出正在进入视图的元素
    const visibleEntries = entries.filter(entry => entry.isIntersecting);
    
    if (visibleEntries.length > 0) {
      // 使用防抖来避免频繁切换
      if (navTimeout.value) clearTimeout(navTimeout.value);
      navTimeout.value = setTimeout(() => {
        // 再次检查是否是程序触发的滚动
        if (isScrollingProgrammatically.value) return;
        
        // 找出可见度最高的元素
        let maxEntry = visibleEntries[0];
        for (const entry of visibleEntries) {
          if (entry.intersectionRatio > maxEntry.intersectionRatio) {
            maxEntry = entry;
          }
        }
        
        const id = maxEntry.target.id;
        if (id && activeTab.value !== id) {
          activeTab.value = id;
          history.replaceState(null, '', `#${id}`);
        }
      }, 50);
    }
  }, { 
    root: null, 
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    rootMargin: '-80px 0px -50% 0px' 
  })

  // 观察所有区块
  const blocks = document.querySelectorAll('.ai-platform-block')
  blocks.forEach(block => {
    // 同时添加到两个观察器
    animationObserver.value.observe(block)
    navObserver.value.observe(block)
  })
}

onMounted(() => {
  // 初始化观察器
  observeBlocks()
  
  // 刷新页面时清除URL中的hash值，并重置activeTab
  if (location.hash) {
    history.replaceState(null, '', location.pathname)
    activeTab.value = 'background'
  }
})

onBeforeUnmount(() => { 
  if (animationObserver.value) animationObserver.value.disconnect()
  if (navObserver.value) navObserver.value.disconnect()
  if (navTimeout.value) clearTimeout(navTimeout.value)
})
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  font-size: 48px;
  color: var(--color-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 8px 24px rgba(255, 255, 255, 0.6);
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.ai-platform-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: var(--color-text);
}

.ai-platform-block { opacity: 0; transform: translateY(30px); transition: opacity 0.6s ease, transform 0.6s ease; }
.ai-platform-block.animate-in { opacity: 1; transform: translateY(0); }
.background-card { width: 100%; box-sizing: border-box; background: #fff; border-radius: 8px; padding: 36px 40px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); border: 1px solid #e8e8e8; }
.background-card:hover { box-shadow: 0 8px 24px rgba(0,0,0,0.12); }
.case-content { max-width: 100%; margin: 0 auto; text-align: left; }
.section-content-cases { text-align: left; }
.case-content-blink { padding: 24px; border-radius: 8px; animation: case-blink 2.5s ease-in-out infinite; }
@keyframes case-blink { 0%,100%{opacity:1;box-shadow:0 0 0 rgba(6,85,159,0)} 50%{opacity:.88;box-shadow:0 0 28px rgba(6,85,159,0.25)} }
.case-section + .case-section { margin-top: 32px; }
.case-subtitle { font-size: 20px; font-weight: 600; color: #06559f; margin-bottom: 12px; }
.case-text { font-size: 14px; line-height: 1.8; color: #333; }
.case-text-full { font-size: 16px; line-height: 1.9; text-align: left; }
.case-list { font-size: 14px; line-height: 1.8; color: #333; padding-left: 0; list-style: none; }
@media (max-width: 1200px) { .mobile-hidden-img { display: none } }

.hero {
  position: relative;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(110deg, #eaf2ff 0%, #f7fbff 40%, #eef5ff 60%, #dfeaff 100%);
  overflow: hidden;
}

.hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(1200px 360px at 75% 20%, rgba(24,144,255,0.18) 0%, rgba(24,144,255,0) 60%),
              radial-gradient(800px 300px at 20% 80%, rgba(64,158,255,0.20) 0%, rgba(64,158,255,0) 60%);
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  padding: 0 24px;
  text-align: left;
}

.hero-inner h1 {
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 18px;
  color: #0f172a;
}

.hero-inner p {
  font-size: 16px;
  line-height: 1.7;
  color: #333;
}

.block { 
      scroll-margin-top: 120px;
    max-width: 1420px;
    margin: 0 auto;
    padding: 60px 20px 90px 20px;
 }

.grid-2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; }
.grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background:  #F5F7FA;;
  /* border: 1px solid #E6EBF5; */
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  border-radius: 6px;
  padding: 30px 30px;
  min-height: 173px;
  box-sizing: border-box;
}

.card-icon { flex-shrink: 0; }
.card-text { display: flex; flex-direction: column;text-align: start; }
.card-title { 
  font-family: PingFang SC;
font-size: 18px;
font-weight: 600;
line-height: normal;
letter-spacing: 0em;

font-variation-settings: "opsz" auto;
color: #000000;
line-height: 40px;
 }
.card-desc { font-size: 14px; line-height: 1.7; color: #666; }

.scenarios {
  display: flex;
  /* grid-template-columns: minmax(0, 1fr) 629px; */
  /* gap: 0; */
  align-items: stretch;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  padding: 23px 0px 0px 40px;
  /* height: 369px; */
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-item { margin-bottom: 18px; }
.scenario-item .item-title { font-size: 16px; line-height: 16px; color: #333; margin-bottom: 8px;font-family: PingFang SC; }
.scenario-item .item-desc { font-size: 14px; line-height: 1.8; color: #666; }
/* .scenario-item.highlight .item-title { color: #FF6A00; } */

.scenario-image {
  background-image: url('@/assets/jiejue/TrafficCompression/right.svg');
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 629px;
  height: 369px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

/* .scenario-image::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.85) 40%, rgba(255,255,255,0) 100%);
  pointer-events: none;
} */

.diagram { display: grid; gap: 12px; }
.layer { background: #fff; border: 1px solid #e6ebf5; border-radius: 6px; }
.layer-title { padding: 10px 14px; font-size: 14px; color: #333; background: #f6f9ff; border-color: #dfe8ff; }
.layer-title.blue { background: #e8f2ff; border-color: #cfe0ff; }
.grid.layer-app { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; padding: 12px; }
.grid.layer-ml { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-data { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-infra { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-app > div,
.grid.layer-ml > div,
.grid.layer-data > div,
.grid.layer-infra > div { background: #f9fbff; border: 1px dashed #e1e9ff; border-radius: 6px; padding: 12px; text-align: center; font-size: 13px; }


.right_img{
  min-height: 348px;
}
@media (max-width: 1200px) {
  .grid-2 { grid-template-columns: 1fr; }
  .grid-4 { grid-template-columns: repeat(2, 1fr); }
  .scenarios { 
    flex-direction: row;
    flex-wrap: wrap;
  }
  .scenario-text {
    width: 50%;
    box-sizing: border-box;
  }
  .right_img {
    width: 50%;
    height: auto;
    object-fit: cover;
    min-height: unset;
  }
}

@media (max-width: 992px) {
  .scenarios {
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .scenario-text {
    padding: 30px 20px;
    border-radius: 4px;
    width: 50%;
    box-sizing: border-box;
  }
  
  .right_img {
    width: 50%;
    height: auto;
    object-fit: cover;
    min-height: unset;
  }
}

@media (max-width: 768px) {
  .product-body { padding: 0 16px 40px; }
  .grid-2 { grid-template-columns: 1fr; }
  .grid-4 { grid-template-columns: 1fr; }
  .grid.layer-ml,
  .grid.layer-data,
  .grid.layer-infra { grid-template-columns: repeat(2, 1fr); }
  .scenario-image { width: 100%; height: 280px; }
  .scenario-text { height: auto; border-radius: 6px; }
  
  .scenarios {
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .scenario-text {
    padding: 20px 15px;
    border-radius: 4px;
    width: 50%;
    box-sizing: border-box;
  }
  
  .right_img {
    width: 50%;
    height: auto;
    object-fit: cover;
    min-height: unset;
  }
 .block-img {
   width: 100%;
 }
}

@media (max-width: 576px) {
  .scenarios {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .product-tabs-bar {
    gap: 20px;
  }
  
  .scenario-text {
    width: 50%;
    padding: 15px 10px;
    box-sizing: border-box;
  }
  
  .right_img {
    width: 50%;
    height: auto;
    object-fit: cover;
  }
  
  .scenario-item .item-title {
    font-size: 14px;
    line-height: 1.4;
  }
  
  .scenario-item .item-desc {
    font-size: 12px;
    line-height: 1.6;
  }
}

.fade-enter-active, .fade-leave-active { transition: opacity .25s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
#advantages { background: linear-gradient(180deg, #F5F7FA 0%, #E0ECFF 100%);max-width: unset; }
.advantages .grid-4 { align-items: stretch; gap: 20px; max-width: 1416px; margin: 0 auto; }
.adv-card { min-height:240px;position: relative; background: #fff;  border-radius: 4px;  padding: 29px; padding-top: 70px; display: flex; flex-direction: column; box-sizing: border-box; text-align: start; }
.adv-badge { position: absolute; top: 33px; left: 29px; width: 24px; height: 24px; border-radius: 4px; background: #1890FF; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 600; }
.adv-title { font-size: 16px; font-family: PingFang SC; color: #333; margin-bottom: 10px; font-weight: 600; }
.adv-desc { font-size: 14px; line-height: 1.6; color: #333; }
.main-content{
  background: #fff;
}
#scenarios{
  max-width: unset;
  background: #F5F7FA;

  /* max-width: 1182px; */
}
</style>

